import React, { Component } from "react";
import CheckIcon from "../Resources/Icons/CheckIcon";

class Avatar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			bgColor: "rgba(1, 95, 209, 0.07)",
		};
	}

	componentDidMount() {
		if (this.props.isRandomBg && this.props.name) {
			let hash = 0;
			for (let i = 0; i < this.props.name.length; i++) {
				hash = this.props.name.charCodeAt(i) + ((hash << 5) - hash);
			}
			let h = hash % 360;
			if (this.props.isDarkColor) {
				let letters = "0123456789ABCDEF".split("");
				let color = "#";
				for (let i = 0; i < 6; i++) {
					color += letters[Math.round(Math.random() * 10)];
				}
				this.setState({ bgColor: color });
				// this.setState({ bgColor: "hsl(" + h + ", " + 30 + "%, " + 40 + "%)" });
			} else {
				this.setState({ bgColor: "hsl(" + h + ", " + 30 + "%, " + 80 + "%)" });
			}
		}
	}

	render() {
		const props = this.props;
		return (
			<div
				className="avatar-placeholder"
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					color: props.isDarkColor ? "#fff" : props.color || "#232f49",
					borderRadius: "50%",
					fontSize: props.fontSize || "12px",
					background: props.checked
						? "rgba(1, 85, 209,0.7)"
						: props.background || this.state.bgColor,
					width: `${props.size}px`,
					height: `${props.size}px`,
				}}
			>
				{props.imageUrl && props.imageUrl !== "" ? (
					<img
						src={`${props.imageUrl}`}
						alt="customer avatar"
						style={{ width: "100%", height: "100%" }}
					/>
				) : (
					<span style={{ lineHeight: 0 }}>
						{props.checked ? (
							<CheckIcon color={"#fff"} height={"16px"} width={"16px"} />
						) : props.name ? (
							props.name.substring(0, 1).toUpperCase()
						) : (
							""
						)}
					</span>
				)}
			</div>
		);
	}
}

export default Avatar;
